// Spoken words (beyond each drawing's own name) that select it, in English.
// Lives here rather than in HomePage so the locale-aware alias lookup can reach
// both languages from one place.
export const ALIASES_EN: Record<string, string[]> = {
  dog: ["dog", "puppy", "doggy", "doggie"],
  cat: ["cat", "kitty", "kitten"],
  horse: ["horse", "horsey", "pony"],
  hedgehog: ["hedgehog", "hedge hog", "porcupine"],
  fish: ["fish", "fishy"],
  dinosaur: ["dinosaur", "dino", "rex", "t rex"],
  butterfly: ["butterfly", "butter fly"],
  flower: ["flower", "flowers"],
  tree: ["tree"],
  sun: ["sun", "sunshine"],
  rainbow: ["rainbow"],
  cloud: ["cloud", "rain", "rain cloud", "clouds"],
  star: ["star"],
  heart: ["heart", "love"],
  house: ["house", "home house"],
  car: ["car", "truck", "vehicle"],
  family: ["family", "people"],
  princess: ["princess"],
  heromask: ["super stormy", "superstormy", "stormy", "superhero", "super hero", "hero"],
  "heromask-7": ["super stormy", "superstormy", "stormy", "superhero", "super hero", "hero"],
  "heromask-10": ["super stormy", "superstormy", "stormy", "superhero", "super hero", "hero"],
  "unicorn-10": ["unicorn", "pegasus", "flying unicorn", "alicorn"],

  // Shapes. These used to live in ShapesPage; they belong here so the alias
  // lookup finds them the same way it finds every other drawing's.
  "shape-circle": ["circle", "round"],
  "shape-crescent": ["crescent", "moon"],
  "shape-diamond": ["diamond", "rhombus"],
  "shape-rectangle": ["rectangle", "oblong"],
};
